import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ConnectionFTPInterface, ConnectionInterface } from '@interface/connection/connection.interface';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { baseReducerActions } from '@util/data/base-reducer-actions';
import { mapifyPayload } from '@util/store/mapify-payload';

import { initialConnectionsState } from './connections.initial-state';

export const connectionsSlice = createSlice({
  name: 'connections',
  initialState: initialConnectionsState,
  reducers: {
    ...baseReducerActions(initialConnectionsState),
    setData: (state, { payload }: PayloadAction<ResponseDataInterface<ConnectionInterface[]>>) => {
      state.data = mapifyPayload(payload.data, 'id');
    },
    setConnection: (state, { payload: { data } }: PayloadAction<ResponseDataInterface<ConnectionInterface>>) => {
      state.data[data.id] = data;
    },
    setFtp: (state, { payload: { data } }: PayloadAction<ResponseDataInterface<ConnectionFTPInterface>>) => {
      state.meta = data;
    },
  },
});

export const connectionsActions = connectionsSlice.actions;
